import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
  FieldArray,
} from 'redux-form';
import {
  Badge,
  Container,
  Card,
  CardBody,
  Col,
  Button,
  Row,
  TabPane,
  TabContent,
  Nav,
  NavItem,
} from 'reactstrap';

import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import TextBox from '../../../../shared/components/form/TextBox';
import DataTable from '../../../../shared/components/DataTable';
import renderSelectField from '../../../../shared/components/form/Select';
import PlaneamientoForm from '../../../Profesor/PlaneamientoForm/index';
import Survey from '../../../MateriasPeriodo/Survey/index';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class MateriaPeriodoForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    onChangeText: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,
    onGetAlumnosMateria: PropTypes.func.isRequired,
    onDownloadAlumnosMateriaNotas: PropTypes.func.isRequired,

    onAddSubjectsSchedule: PropTypes.func.isRequired,
    onDeleteSubjectSchedule: PropTypes.func.isRequired,

    onBack: PropTypes.func.isRequired,

    loading: PropTypes.bool.isRequired,
    editarAsistencias: PropTypes.bool.isRequired,
    tipoActividadAcademicaHorarios: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    submitting: PropTypes.bool,
    profesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    materias: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    history: PropTypes.shape({}).isRequired,
    materiaPeriodo: PropTypes.shape({}).isRequired,

    diasSemana: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    filters: PropTypes.shape({}).isRequired,
    horarios: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    loadingAlumnosMateria: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    totalItemsCount: PropTypes.number.isRequired,

    profesor: PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    profesorAuxiliar1: PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    profesorAuxiliar2: PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    profesorAuxiliar3: PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    submitting: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
    };

    this.columns = ({
      calculatePPFromTasks,
      canEditTask,
    }) => {
      const cols = [
        {
          key: 'numeroDocumento',
          name: 'Nro documento',
          width: '120px',
          search: true,
        },
        {
          key: 'apellidoAlumno',
          name: 'Apellido',
          visible: false,
          search: true,
        },
        {
          key: 'nombreAlumno',
          name: 'Nombre',
          search: true,
          format: row => `${row.apellidoAlumno}, ${row.nombreAlumno}`.trim(),
        },
        { key: 'email', name: 'E-Mail' },
        { key: 'mallaNombre', name: 'Malla' },
      ];

      return [
        ...cols,
        ...[
          {
            key: 'porcentajePP',
            name: '% PP',
            editable: !calculatePPFromTasks && canEditTask,
            type: 'number',
            min: 0,
            max: 100,
            width: '100px',
            className: 'text-center',
            inputStyle: () => this.inputStyle,
            format: ({ porcentajePP }) => (
              <Badge
                color="primary"
                pill
                style={{
                  fontSize: '15px',
                  textAlign: 'center',
                  fontWeight: 'normal',
                }}
              >
                {porcentajePP}
              </Badge>
            ),
          },
          {
            key: 'porcentajeAsistencia',
            name: '% Asistencia',
            type: 'number',
            min: '0',
            max: '100',
            width: '110px',
            className: 'text-center',
            inputStyle: () => this.inputStyle,
            format: ({ porcentajeAsistencia }) => (
              <Badge
                color="primary"
                pill
                style={{
                  fontSize: '15px',
                  textAlign: 'center',
                  fontWeight: 'normal',
                }}
              >
                {Math.round(porcentajeAsistencia)}
              </Badge>
            ),
          },
          {
            key: 'actions',
            name: 'Accion',
            width: '100px',
            visible: false,
          },
        ],
      ];
    };

    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar notas" />,
        callback: (inscription) => {
          this.editarNotas(inscription);
        },
      },
    ];
  }

  onDataTableSubmit = (values) => {
    if (values) {
      const { onGetAlumnosMateria, filters: { pageSize } } = this.props;
      onGetAlumnosMateria(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { onGetAlumnosMateria, filters = { pageSize: 250 } } = this.props;
    onGetAlumnosMateria(1, filters.pageSize, filters);
  };

  toggle = (tab) => {
    const { onGetAlumnosMateria } = this.props;
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({ activeTab: tab });
      if (tab === '2') {
        onGetAlumnosMateria();
      }
    }
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  getProfesoresMateria = () => {
    const {
      profesor, profesorAuxiliar1, profesorAuxiliar2, profesorAuxiliar3,
    } = this.props;

    return [
      profesor || {},
      profesorAuxiliar1 || {},
      profesorAuxiliar2 || {},
      profesorAuxiliar3 || {},
    ].filter(p => p.value);
  }

  renderHorarios = ({
    fields = [],
    tipoActividadAcademicaHorarios = [],
    diasSemana = [],
    horarios = [],
  }) => {
    const {
      onAddSubjectsSchedule, onDeleteSubjectSchedule, onChangeText, onChangeSelect,
    } = this.props;

    const profesoresMateria = this.getProfesoresMateria();

    const showBtnAdd = () => {
      if (profesoresMateria.length === 0) {
        return (
          <Col md={9} lx={12}>
            <div>
              <h4>
                <Badge color="warning">
                  Debe seleccionar un profesor (Encargado o Auxiliar) para agregar los horarios.
                </Badge>
              </h4>
            </div>
          </Col>
        );
      }

      return (
        <Col md={9} lg={3} lx={12}>
          <Button
            size="sm"
            color="primary"
            style={{ marginBottom: '0px' }}
            onClick={() => onAddSubjectsSchedule()}
            className="font-weight-bold"
          >
            <i className="fa fa-plus" />
            {' '}
            Agregar
          </Button>
        </Col>
      );
    };


    return (
      <div className="table-wrapper">
        <table className="table table-striped check-in">
          <thead>
            <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
              <th colSpan={8}>
                <div className="invoice-detail">
                  <Row>
                    <Col md={2} lg={2}>
                      <h4>Horario de clases</h4>
                    </Col>
                    {showBtnAdd()}
                  </Row>
                </div>
              </th>
            </tr>
            <tr>
              <th scope="col col-1">#</th>
              <th scope="col col-1">Tipo Actividad</th>
              <th scope="col col-1">Profesor</th>
              <th className="text-center" scope="col col-1">D&iacute;a</th>
              <th className="text-center" scope="col col-1">Aula</th>
              <th className="text-center" scope="col col-1">Hora Inicio</th>
              <th className="text-center" scope="col col-1">Hora Fin</th>
              <th scope="col col-1">{' '}</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((horario, index) => {
              if (!horarios[index]) {
                return null;
              }

              return (
                <tr key={`${horario}`} className={horarios[index].deleted ? 'hidden' : ''}>
                  <th colSpan="2" className="col col-2 text-right">
                    <div className="form" style={{ flexWrap: 'nowrap', alignItems: 'center', columnGap: '1rem' }}>
                      <h4>{index + 1}</h4>
                      <Field
                        name={`${horario}.tipoActividadAcademicaHorario`}
                        placeholder="Tipo Actividad"
                        onChange={props => onChangeSelect({
                          option: props, name: 'tipoActividadAcademicaHorario', index,
                        })}
                        options={tipoActividadAcademicaHorarios}
                        component={renderSelectField}
                      />
                    </div>
                  </th>
                  <th className="col col-3">
                    <div className="form" style={{ display: 'flex' }}>
                      <Field
                        name={`${horario}.profesor`}
                        placeholder="Profesor"
                        onChange={props => onChangeSelect({ option: props, name: 'profesor', index })}
                        options={profesoresMateria}
                        component={renderSelectField}
                      />
                    </div>
                  </th>
                  <th className="col col-1">
                    <div className="form" style={{ display: 'flex' }}>
                      <Field
                        name={`${horario}.dia`}
                        placeholder="D&iacute;a"
                        onChange={props => onChangeSelect({ option: props, name: 'dia', index })}
                        options={diasSemana}
                        component={renderSelectField}
                      />
                    </div>
                  </th>
                  <th className="col col-1 text-center">
                    <div className="form" style={{ display: 'flex' }}>
                      <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                        <Field
                          name={`${horario}.aula`}
                          placeholder="Aula"
                          type="text"
                          maxLength="64"
                          component={TextBox}
                          autoComplete="false"
                          onChange={v => onChangeText(v, index)}
                        />
                      </div>
                    </div>
                  </th>
                  <th className="col col-1 text-center">
                    <div className="form" style={{ display: 'flex' }}>
                      <Field
                        name={`${horario}.horaInicio`}
                        placeholder="Hora Inicio"
                        type="time"
                        component={TextBox}
                        autoComplete="false"
                        onChange={v => onChangeText(v, index)}
                      />
                    </div>
                  </th>
                  <th className="col col-1 text-center">
                    <div className="form" style={{ display: 'flex' }}>
                      <Field
                        name={`${horario}.horaFin`}
                        placeholder="Hora Fin"
                        onInputChange={this.handleInputChange}
                        type="time"
                        component={TextBox}
                        autoComplete="false"
                        onChange={v => onChangeText(v, index)}
                      />
                    </div>
                  </th>
                  <th>
                    <Button
                      onClick={() => onDeleteSubjectSchedule({ index })}
                      size="sm"
                      outline
                      color="danger"
                      style={{ marginBottom: '0px' }}
                      className="font-weight-bold"
                    >
                      <i className="fa fa-trash" aria-hidden="true" />
                    </Button>
                  </th>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  planeamientoForm = () => {
    const { materiaPeriodo } = this.props;
    return (
      <PlaneamientoForm
        planningId={materiaPeriodo.id}
        materiaPeriodo={{
          ...materiaPeriodo,
          canEditarPlaneamiento: false,
        }}
      />
    );
  };

  moveSection = () => {
    const { materiaPeriodo, history } = this.props;
    history.push(`/pages/periodos/subjects/edit/${materiaPeriodo.periodoId}/${materiaPeriodo.id}/move-section`);
  };

  render() {
    const { loading } = this.props;

    if (loading) {
      return <LoadingSpinner />;
    }

    const {
      submitting,
      handleSubmit,
      onFilterChanges,
      onBack,
      onDownloadAlumnosMateriaNotas,
      profesores,
      materias,
      materiaPeriodo,
      horarios,
      diasSemana,
      tipoActividadAcademicaHorarios,
      editarAsistencias,
      loadingAlumnosMateria,
      items,
      totalItemsCount,
      filters,
    } = this.props;

    const { malla, periodo } = materiaPeriodo;

    const {
      activeTab,
    } = this.state;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={12} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos de la materia por periodo</h5>
                </div>
              </Col>
              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Malla</span>
                  <div className="form__form-group-field">
                    <input
                      value={`${malla.label}`}
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Periodo</span>
                  <div className="form__form-group-field">
                    <input
                      value={`${periodo.value} - ${periodo.label}`}
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Materia</span>
                  <div className="form__form-group-field">
                    <Field
                      name="materia"
                      component={renderSelectField}
                      placeholder="Materia"
                      autoComplete="false"
                      options={materias}
                    />
                  </div>
                </div>
              </Col>

              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Profesor Encargado</span>
                  <div className="form__form-group-field">
                    <Field
                      name="profesor"
                      component={renderSelectField}
                      placeholder="Profesor"
                      autoComplete="false"
                      options={profesores}
                      onChange={v => onFilterChanges('profesor', 'profesorId', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Profesor Auxiliar</span>
                  <div className="form__form-group-field">
                    <Field
                      name="profesorAuxiliar1"
                      component={renderSelectField}
                      placeholder="Profesor Auxiliar"
                      autoComplete="false"
                      options={profesores}
                      onChange={v => onFilterChanges('profesorAuxiliar1', 'profesorAuxiliar1Id', v)}
                    />
                  </div>
                </div>
              </Col>

              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Profesor Auxiliar</span>
                  <div className="form__form-group-field">
                    <Field
                      name="profesorAuxiliar2"
                      component={renderSelectField}
                      placeholder="Profesor Auxiliar"
                      autoComplete="false"
                      options={profesores}
                      onChange={v => onFilterChanges('profesorAuxiliar2', 'profesorAuxiliar2Id', v)}
                    />
                  </div>
                </div>
              </Col>

              <Col md={4} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Profesor Auxiliar</span>
                  <div className="form__form-group-field">
                    <Field
                      name="profesorAuxiliar3"
                      component={renderSelectField}
                      placeholder="Profesor Auxiliar"
                      autoComplete="false"
                      options={profesores}
                      onChange={v => onFilterChanges('profesorAuxiliar3', 'profesorAuxiliar3Id', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">{' '}</span>
                  <div className="form__form-group-field">
                    <Field
                      name="editarAsistencias"
                      component={renderCheckBoxField}
                      label="Asistencias Editable?"
                      value={editarAsistencias ? 'checked' : ''}
                      defaultChecked={editarAsistencias}
                    />
                  </div>
                </div>
              </Col>

              <Col md={2} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Secci&oacute;n</span>
                  <div className="form__form-group-field">
                    <Field
                      name="seccion"
                      placeholder="Secci&oacute;n"
                      type="text"
                      maxLength="16"
                      component={TextBox}
                      autoComplete="false"
                    />
                  </div>
                </div>

              </Col>

              <Col md={3} lx={12} style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                  <Button
                    size="sm"
                    color="primary"
                    style={{ marginBottom: '0px' }}
                    onClick={this.moveSection}
                    className="font-weight-bold"
                  >
                    <i className="fa fa-share" />
                    {' '}
                    Mover alumnos
                  </Button>
                </div>
              </Col>

            </Form>
            <hr />

            {/* <FieldArray
              name="horarios"
              component={this.renderHorarios}
              horarios={horarios}
              diasSemana={diasSemana}
              tipoActividadAcademicaHorarios={tipoActividadAcademicaHorarios}
            /> */
            }

            <Container>
              <Nav tabs style={{ gap: '0.3rem' }}>
                <NavItem className="">
                  {activeTab === '1'
                    ? (<Button active color="secondary" className="mb-0">Horario de clases</Button>)
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        onClick={() => this.toggle('1')}
                      >
                        Horario de clases
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem className="">
                  {activeTab === '2'
                    ? (<Button active color="secondary" className="mb-0">Calificaciones</Button>)
                    : (
                      <Button outline color="secondary" className="mb-0" onClick={() => this.toggle('2')}>
                        Calificaciones
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem className="">
                  {activeTab === '3'
                    ? (
                      <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                        Planeamiento
                      </Button>
                    )
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => this.toggle('3')}
                      >
                        Planeamiento
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem>
                  {activeTab === '4'
                    ? (
                      <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                        Encuestas
                      </Button>
                    )
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => this.toggle('4')}
                      >
                        Encuestas
                      </Button>
                    )
                  }
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane className="tabs--bordered-top" tabId="1">
                  <Row>
                    <FieldArray
                      name="horarios"
                      component={this.renderHorarios}
                      horarios={horarios}
                      diasSemana={diasSemana}
                      tipoActividadAcademicaHorarios={tipoActividadAcademicaHorarios}
                      activeTab={activeTab}
                    />
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    {
                      loadingAlumnosMateria ? (
                        <Col md={12} className="text-center">
                          <LoadingSpinner />
                        </Col>
                      )
                        : (
                          <>
                            <Col md={12}>
                              <div className="text-left">
                                <button
                                  style={{ height: '3rem' }}
                                  className="btn btn-link btn mb-0 pt-1 pb-1"
                                  type="button"
                                  onClick={onDownloadAlumnosMateriaNotas}
                                >
                                  <span className="fa fa-cloud-download">&nbsp;</span>
                                  Descargar lista
                                </button>
                              </div>
                            </Col>
                            <DataTable
                              title="Listado de todas las notas"
                              columns={this.columns({
                                canEditTask: materiaPeriodo.canEditTask,
                                calculatePPFromTasks: materiaPeriodo.calculatePPFromTasks,
                                showAssistPercentageInScores: materiaPeriodo.showAssistPercentageInScores,
                              })}
                              items={items}
                              onChangePage={this.onChangePage}
                              totalItemsCount={totalItemsCount}
                              onSubmit={this.onDataTableSubmit}
                              onClearFilters={this.onDataTableClearFilters}
                              getGridActions={key => this.getGridActions(key)}
                              onAutoSave={this.autoguardarNota}
                              itemsToShow={items.length}
                              page={1}
                              pageSize={totalItemsCount}
                              autoHideSearch={filters.autoHideSearch}
                              initialValues={filters}
                              enableReinitialize
                            />
                          </>
                        )
                    }
                  </Row>
                </TabPane>
                <TabPane tabId="3">
                  <Row>
                    {this.planeamientoForm()}
                  </Row>
                </TabPane>
                <TabPane tabId="4">
                  <Row>
                    <Survey
                      materiaPeriodoId={materiaPeriodo.id}
                      finCalificarTareas={materiaPeriodo.finCalificarTareas}
                      canEdit={materiaPeriodo.canEditTask}
                      utilizaPorcentajePesoMateria={materiaPeriodo.utilizaPorcentajePesoMateria}
                      handleSubmit={this.handleChangeUtilizaPorcentajePesoMateria}
                    />
                  </Row>
                </TabPane>
              </TabContent>
            </Container>

            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxMateriaPeriodoForm = reduxForm({
  form: 'MateriaPeriodoForm',
  validate,
  enableReinitialize: true,
})(MateriaPeriodoForm);

export default setPropsAsInitialValues(ReduxMateriaPeriodoForm);
